import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-WorkPlacements', [
  'placementsTable',
  'placementRow',
  'emptyState',
  'loadingSpinner',
  'addEmployerTrigger',
  'addEmployerModal',
  'employerNameInput',
  'employerAbnInput',
  'employerBusinessTypeSelect',
  'employerBusinessTypeOtherInput',
  'contactFirstNameInput',
  'contactLastNameInput',
  'contactEmailInput',
  'contactPhoneInput',
  'contactPreferredMethodSelect',
  'step1NextButton',
  'readyForPlacementsToggle',
  'agreementUpload',
  'insuranceUpload',
  'agreementExpiryInput',
  'insuranceExpiryInput',
  'step2NextButton',
  'courseToggle',
  'saveEmployerButton',
  'employerRow',
  'employerDrawer',
  'drawerDetailsSection',
  'drawerAddressSection',
  'drawerContactsSection',
  'drawerStatusSection',
  'drawerCoursesSection',
  'employerPlacementsTable',
  'employerPlacementRow',
  'placementStage',
  'placementsEmpty',
  'placementsError',
  'employerCapacityInput',
  'doNotUseToggle',
  'addContactButton',
  'editContactButton',
  'removeContactButton',
  'contactPrimaryToggle',
  'employerNotesList',
  'employerNoteItem',
  'noteTextInput',
  'addNoteTrigger',
  'addNoteButton',
  'cancelNoteButton',
  'notesEmptyState',
  'notesErrorState',
  'recentContactsPanel',
  'contactLogItem',
  'logContactTypeSelect',
  'logContactDateTimeInput',
  'logContactResultInput',
  'logContactContactSelect',
  'logContactNotesInput',
  'newContactFirstNameInput',
  'newContactLastNameInput',
  'newContactEmailInput',
  'newContactPhoneInput',
  'addToContactsToggle',
  'saveLogContactButton',
  'contactLogMenuButton',
  'editContactLogMenuItem',
]);
